"use client";

import React from 'react';
import Image from "next/image";

interface ThumbProps {
    selected: boolean;
    src: string;
    onClick: () => void;
    imageFit?: 'contain' | 'cover';
}

export const Thumb: React.FC<ThumbProps> = ({ selected, src, onClick, imageFit = 'cover' }) => {
    return (
        <div
            className={
                'embla-thumbs__slide' + (selected ? ' embla-thumbs__slide--selected' : '')
            }
        >
            <button
                onClick={onClick}
                type="button"
                className="embla-thumbs__slide__number aspect-square !h-auto !rounded-lg md:!rounded-xl"
                aria-label={`Выбрать изображение ${selected ? '(выбрано)' : ''}`}
            >
                <Image
                    src={src}
                    width={90}
                    height={90}
                    alt="Миниатюра товара"
                    unoptimized
                    className="w-full h-full"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: imageFit
                    }}
                />
            </button>
        </div>
    );
};
